import React, { FC } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import generateComponentStyles from '../../../utils/styleHelper';

import * as styles from './ContainerSkeleton.module.scss';

type SkeletonBaseProps = {
  style: any;
  skipStates?: boolean;
  baseScreenResolution?: number;
  nested?: boolean;
  parentStyle?: any;
}

const StyledContainer = styled.div<{
  $shape?: any;
  $baseScreenResolution?: number;
  $skipStates?: boolean;
  $nested?: boolean;
  $parentDisplay?: string;
  $parentFlexDirection?: string;
}>`
  ${(props) => generateComponentStyles(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
    position: relative;
    visibility: visible;
    pointer-events: none;
  ${(props) => props.$nested && `
    position: absolute;
    z-index: 99999999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `}
`;

const ContainerSkeleton: FC<SkeletonBaseProps> = ({
  style,
  skipStates,
  baseScreenResolution,
  nested,
  parentStyle,
}) => (
  <StyledContainer
    $shape={{
      display: style.display,
      grid: style.grid,
      flex: style.flex,
      width: nested ? undefined : style.width,
      height: nested ? undefined : style.height,
      min_height: !style.height ? '16px' : undefined,
      border: { radius: style?.border?.radius, },
      }}
      $baseScreenResolution={baseScreenResolution}
      $skipStates={skipStates}
      $nested={nested}
      $parentDisplay={parentStyle?.display}
      $parentFlexDirection={typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined}
      className={cn('shimmer-container', styles.container)}
  >
    </StyledContainer>
);

export default ContainerSkeleton;